"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAnalytics = void 0;
class GoogleAnalytics {
    constructor() {
        this._tokens = new Set();
    }
    addUniversalToken(gaToken) {
        // ensure duplicates not added or processed
        if (this._tokens.has(gaToken)) {
            return;
        }
        this._tokens.add(gaToken);
        const gInstance = gtag;
        if (gInstance) {
            gInstance("config", gaToken, {
                "custom_map": {
                    "dimension1": "application_id",
                    "dimension2": "application_title",
                    'dimension3': 'platform'
                }
            });
            gInstance("event", "app_dimension", { "platform": "Viewer" });
        }
    }
    addToken(gaToken) {
        // ensure duplicates not added or processed
        if (this._tokens.has(gaToken)) {
            return;
        }
        this._tokens.add(gaToken);
        const gInstance = gtag;
        if (gInstance) {
            gInstance("config", gaToken, {
                "custom_map": {
                    "dimension1": "application_id",
                    "dimension2": "application_title",
                }
            });
        }
    }
    write(event, data) {
        if (this._tokens.size <= 0) {
            return;
        }
        this._tokens.forEach((token) => {
            const gInstance = gtag;
            if (gInstance) {
                const eventCategory = data.get("eventCategory"); // 0
                const eventAction = data.get("eventAction"); // 1
                const eventLabel = data.get("eventLabel"); // 2
                var fields = {
                    "send_to": token,
                    "event_category": eventCategory,
                    "event_label": eventLabel
                };
                data.map.forEach((value, key) => {
                    fields[key] = value;
                });
                if (event === "track") {
                    gInstance("event", eventAction, fields);
                }
                if (event === "pageview") {
                    gInstance("event", "pageview", fields);
                }
            }
        });
    }
}
exports.GoogleAnalytics = GoogleAnalytics;
